// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3sPr3","list":"BalanceDue_list__Jh6eZ","listRow":"BalanceDue_listRow__Id2c8","total":"BalanceDue_total__k_0Xs"};